"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TileHighlightOnScroll = /*#__PURE__*/function () {
  function TileHighlightOnScroll(container, isSecond, fullWidth) {
    var _this = this;
    _classCallCheck(this, TileHighlightOnScroll);
    this.OPACITY_RATIO = 0.01;
    this.window = $(window);
    this.isSecond = isSecond;
    this.fullWidth = fullWidth;
    this.container = container;
    this.platform = new Platform();
    this.rolloverLayer = $('.rollover', this.container);
    this.containerHeight = null;
    this.tileOffsetTop = null;
    this.windowCenter = null;
    this.initValues();
    this.window.resize(function () {
      _this.initValues();
      _this.highlightTile();
    });
    this.highlightTile();
    this.window.scroll(function () {
      _this.highlightTile();
    });
  }
  _createClass(TileHighlightOnScroll, [{
    key: "initValues",
    value: function initValues() {
      this.containerHeight = this.container.height();
      this.tileOffsetTop = this.rolloverLayer.offset().top;
      this.windowCenter = Math.round(this.window.innerHeight() * 0.65);
    }
  }, {
    key: "highlightTile",
    value: function highlightTile() {
      var windowScrollTop = this.window.scrollTop();
      if (this.platform.isPhone()) {
        if (windowScrollTop + this.windowCenter >= this.tileOffsetTop && windowScrollTop + this.windowCenter <= this.tileOffsetTop + this.containerHeight) {
          var setOpacity = Math.min((windowScrollTop + this.windowCenter - this.tileOffsetTop) * this.OPACITY_RATIO, 1);
          this.rolloverLayer.css({
            opacity: setOpacity
          });
        } else if (windowScrollTop + this.windowCenter > this.tileOffsetTop + this.containerHeight) {
          var _setOpacity = Math.max(1 + (this.tileOffsetTop + this.containerHeight - (windowScrollTop + this.windowCenter)) * this.OPACITY_RATIO, 0);
          this.rolloverLayer.css({
            opacity: _setOpacity
          });
        } else {
          this.rolloverLayer.css({
            opacity: 0
          });
        }
      } else {
        if (this.fullWidth) {
          if (windowScrollTop + this.windowCenter >= this.tileOffsetTop && windowScrollTop + this.windowCenter <= this.tileOffsetTop + this.containerHeight) {
            var _setOpacity2 = Math.min((windowScrollTop + this.windowCenter - this.tileOffsetTop) * this.OPACITY_RATIO, 1);
            this.rolloverLayer.css({
              opacity: _setOpacity2
            });
          } else if (windowScrollTop + this.windowCenter > this.tileOffsetTop + this.containerHeight) {
            var _setOpacity3 = Math.max(1 + (this.tileOffsetTop + this.containerHeight - (windowScrollTop + this.windowCenter)) * this.OPACITY_RATIO, 0);
            this.rolloverLayer.css({
              opacity: _setOpacity3
            });
          } else {
            this.rolloverLayer.css({
              opacity: 0
            });
          }
        } else {
          if (this.isSecond) {
            if (windowScrollTop + this.windowCenter >= this.tileOffsetTop + this.containerHeight * 0.5 && windowScrollTop + this.windowCenter <= this.tileOffsetTop + this.containerHeight) {
              var _setOpacity4 = Math.min((windowScrollTop + this.windowCenter - (this.tileOffsetTop + this.containerHeight * 0.5)) * this.OPACITY_RATIO, 1);
              this.rolloverLayer.css({
                opacity: _setOpacity4
              });
            } else if (windowScrollTop + this.windowCenter > this.tileOffsetTop + this.containerHeight) {
              var _setOpacity5 = Math.max(1 + (this.tileOffsetTop + this.containerHeight - (windowScrollTop + this.windowCenter)) * this.OPACITY_RATIO, 0);
              this.rolloverLayer.css({
                opacity: _setOpacity5
              });
            } else {
              this.rolloverLayer.css({
                opacity: 0
              });
            }
          } else {
            if (windowScrollTop + this.windowCenter >= this.tileOffsetTop && windowScrollTop + this.windowCenter <= this.tileOffsetTop + this.containerHeight * 0.5) {
              var _setOpacity6 = Math.min((windowScrollTop + this.windowCenter - this.tileOffsetTop) * this.OPACITY_RATIO, 1);
              this.rolloverLayer.css({
                opacity: _setOpacity6
              });
            } else if (windowScrollTop + this.windowCenter > this.tileOffsetTop + this.containerHeight * 0.5) {
              var _setOpacity7 = Math.max(1 + (this.tileOffsetTop + this.containerHeight * 0.5 - (windowScrollTop + this.windowCenter)) * this.OPACITY_RATIO, 0);
              this.rolloverLayer.css({
                opacity: _setOpacity7
              });
            } else {
              this.rolloverLayer.css({
                opacity: 0
              });
            }
          }
        }
      }
    }
  }]);
  return TileHighlightOnScroll;
}();